import React, { Component } from 'react';
import c3 from 'c3';
import 'c3/c3.css';
import './chart.css';
import { isEmpty } from '../Common/Common';

export default class Chart_Line extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}

		this.chart = null;
	}

	componentDidMount() {
		this.generateChart();
		window.addEventListener('resize', this.generateChart);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.generateChart);
	}

	generateChart = () => {
		let width = this.props.chart_width;
		let height = this.props.chart_height;
		let chart_data = this.props.data;

		let colors = {};
		if (!isEmpty(this.props.colors)) colors = this.props.colors;

		// Time series display format
		// https://c3js.org/samples/timeseries.html
		let display_time_format = '%d-%b %H:%M';

		this.chart = c3.generate({
			bindto: "#chart_" + this.props.id,
			size: {
				width: width,
				height: height,
			},
			data: {
				x: 'x',
				//xFormat: '%m%d %H:%M', // 'xFormat' can be used as custom format of 'x'
				xFormat: '%Y-%m-%d %H:%M:%S', // Input time series format
				columns: this.props.data,
				type: 'line',
				colors: colors,
			},
			point: { show: false },
			legend: { padding: 20 },
			axis: {
				x: {
					show: true,
					type: 'timeseries',
					tick: {
						format: display_time_format, // Display time series format
						values: this.props.tick_values,
						rotate: -45,
					},
					padding: { left: 0, right: 0 }
				},
				y: {
					max: this.props.maxValue, // cutoff anything above 300. Used to extend for threshold
					min: this.props.minValue, // cutoff anything below 100. Used to extend for threshold
					label: {
						text: this.props.y_label,
						position: 'outer-middle'
					},
					tick: {
						format: function (d) {
							if (Math.abs(d) >= 1000000) return (d / 1000000).toFixed(1) + 'M';
							else if (Math.abs(d) >= 1000) return (d / 1000).toFixed(1) + 'K';
							else return d;
						},
					},
				}
			},
			title: {
				text: this.props.title,
				position: 'top-center',   // top-left, top-center and top-right
			},
			grid: {
				y: {
					lines: this.props.ygrids
				}
			}
		})

		return this.chart;
	}

	render() {
		let style = {};
		style = Object.assign(style, this.props.style);

		return (
			<div id={"chart_" + this.props.id} style={style} />
		);
	}
}